import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { WrapperStandardFilter, WrapperStandardRequest } from '../../common/models/wrapper.model';
import { GenericService } from "../../services/base/generic-service";
import { GenericListViewProperties } from "./generic-list-view-properties";
import { BehaviorSubject } from 'rxjs';
import { GlobalProperties } from "src/app/global/global-properties";


@Component({
    template: ''
})
export class GenericListViewFunctions<T> extends GenericListViewProperties<T> {
    active = false;
    filter_data: any[] = [];
    filterUpdateSubject = new BehaviorSubject(false);
    constructor(private genericService: GenericService<T>, public router: Router) {
        super();
    }


    populatedata: any[] = [];
    async PopulateListViewGeneric(aUrl: string, aRequestData: WrapperStandardRequest<any>): Promise<Array<T>> {
        let userGuid = sessionStorage.getItem('UserGuid');
        aRequestData.UserGuid = userGuid ? userGuid : GlobalProperties._userGUID;



        let result = this.genericService.PostAPIWithWrapperRequestAndReturnsArrayOfT(aUrl, aRequestData);
        result.then((result: any) => {
            this.setListViewDataSource = result.responseData;
            this.setRowCount = result.rowCount;
        })
        return await result;
    }

    onClickOfGenericViewButton(dataId: string) {
        this.router.navigate([this.getEntryFormRouteTo, dataId]);
    }

    onClickOfGenericSelectButton(dataId: string) {
        this.router.navigate([this.getEntryFormRouteTo, dataId]);
    };

    onClickOfGenericEditButton(dataId: string | number, data2?: string | number) {

        this.router.navigate(

            data2 != null
                ? [this.getEntryFormRouteTo, dataId, data2]
                : [this.getEntryFormRouteTo, dataId],
            { skipLocationChange: true });
    };

    onClickOfGenericRow(event: any) {
        alert(event);

    };

    onClickOfGenericPaginator(event: any) {
        this.getRequestData.PageRecordCount = event.pageSize;
        this.getRequestData.PageSize = event.pageIndex + 1;
        this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData);
    }

    onClickOfGenericPaginatorCFL(event: any) {
        this.getRequestData.PageRecordCount = event.pageSize;
        this.getRequestData.PageSize = event.pageIndex + 1;
        this.PopulateListViewGenericForOnScrollPagination(this.getListViewDataSourceURL, this.getRequestData);
    }

    onClickOfGenericNewButton() {
        this.router.navigate([this.getEntryFormRouteTo.concat("/0")], { skipLocationChange: true });

    };

    onClickOfGenericColumnSort(sortColumn: string, isAcending: boolean) {
        this.getRequestData.SortColumn = sortColumn;
        this.getRequestData.IsAcending = isAcending;
        this.active = !this.active;
        this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData);
    };

    onClickOfGenericFilterButtonForRangeString(column: any, from: any, to: any, labelType: any) {
        let filter: WrapperStandardFilter = new WrapperStandardFilter();
        //this._filterArray = [];
        let arr: any = [];
        if (this._filterArray) {
            arr = this._filterArray.filter(function (el: any) {
                return el.Key !== column;
            });
        } else {
            this._filterArray = [];
        }
        this.setFilterArrCustom = arr;

        filter.Key = column;
        filter.OperatorType = "startswith";
        filter.Value = from;
        this.setFilterArray = filter;

        filter = new WrapperStandardFilter();
        filter.Key = column;
        filter.OperatorType = "endswith";
        filter.Value = to;
        this.setFilterArray = filter;
        if (from || to) {
            this.onCreateFilterChip(column, from, to, labelType);
        }
        this.getRequestData.PageSize = 1;
        this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData);
    };

    onClickOfGenericFilterButtonForRangeNumber(column: string, from: string, to: string, labelType: string) {
        let filter: WrapperStandardFilter = new WrapperStandardFilter();
        //this._filterArray = [];
        let arr: any = [];
        if (this._filterArray) {
            arr = this._filterArray.filter(function (el: any) {
                return el.Key !== column;
            });
        } else {
            this._filterArray = [];
        }
        this.setFilterArrCustom = arr;

        filter.Key = column;
        filter.OperatorType = ">=";
        filter.Value = from;
        this.setFilterArray = filter;

        filter = new WrapperStandardFilter();
        filter.Key = column;
        filter.OperatorType = "<=";
        filter.Value = to;
        this.setFilterArray = filter;
        if (from || to) {
            this.onCreateFilterChip(column, from, to, labelType);
        }
        this.getRequestData.PageSize = 1;
        this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData);
    };

    onCreateFilterChip(column: string, fromVal: any, toVal: any, label: any) {
        if (this.selectedFilterList.some((item: any) => item.label == column)) {
            let filterIndex: any = this.selectedFilterList.findIndex((item: any) => item.label == column);
            this.selectedFilterList.splice(filterIndex, 1, {
                label: column,
                from: fromVal,
                to: toVal,
                labelType: label
            })
        } else {
            this.selectedFilterList.push({
                label: column,
                from: fromVal,
                to: toVal,
                labelType: label
            });
        }
    }

    onRemoveChip(i: any, item: any) {
        this.selectedFilters.splice(i, 1);
        var arr = this.getRequestData.RequestData.filter(function (el: any) {
            return el.Key !== item.label;
        });
        this.setFilterArrCustom = arr
        this.getRequestData.RequestData = arr;
        this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData)

    }

    async onRemoveChipCFL(i: any, item: any) {
        this.selectedFilters.splice(i, 1);
        var arr = this.getRequestData.RequestData.filter(function (el: any) {
            return el.Key !== item.label;
        });
        this.setFilterArrCustom = arr
        this.getRequestData.RequestData = arr;

        this.setListViewDataSourceOnScrollPagination = [];
        await this.PopulateListViewGenericForOnScrollPagination(this.getListViewDataSourceURL, this.getRequestData);
        this.filterUpdateSubject.next(true);
    }


    onClickOfGenericClearAllFilter() {
        let filter = new WrapperStandardFilter();
        this.setFilterArray = filter;
    }

    onClickOfGenericClearFilter(index: number) {
        this.getFilterArray.splice(index, 1);
    }

    onClickOfGenericFilterButtonForDate(column: string, from: string, to: string, labelType: string) {
        let filter: WrapperStandardFilter = new WrapperStandardFilter();
        let arr: any = [];
        if (this._filterArray) {
            arr = this._filterArray.filter(function (el: any) {
                return el.Key !== column;
            });
        } else {
            this._filterArray = [];
        }
        this.setFilterArrCustom = arr;
        filter.Key = column;
        filter.OperatorType = ">=";
        filter.Value = from.split("-").reverse().join("-");
        //filter.Value = fromDate;
        this.setFilterArray = filter;

        filter = new WrapperStandardFilter();
        filter.Key = column;
        filter.OperatorType = "<=";
        filter.Value = to.split("-").reverse().join("-");
        this.setFilterArray = filter;
        if (from || to) {
            this.onCreateFilterChip(column, from, to, labelType);
        }
        this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData);
    };


    //Scroll Pagination
    async PopulateListViewGenericForOnScrollPagination(aUrl: string, aRequestData: WrapperStandardRequest<any>): Promise<T> {
        let result = await this.genericService.PostAPIWithOnScrollPaginationWrapperRequestAndReturnsArrayOfT(aUrl, aRequestData);
        // result.then((result: any) => {

        //     this.setListViewDataSourceOnScrollPagination = result.responseData;
        //     this.setCurrentPage = result.currentPage;
        //     this.setPageRecordCount = result.pageRecordCount;
        //     this.setPageSize = result.pageSize;
        //     this.setRowCount = result.rowCount;
        // })
        this.setListViewDataSourceOnScrollPagination = result.responseData;
        this.setCurrentPage = result.currentPage;
        this.setPageRecordCount = result.pageRecordCount;
        this.setPageSize = result.pageSize;
        this.setRowCount = result.rowCount;
        return result;
    }


    //For Enum Data Filter 

    onClickOfGenericFilterButtonForEnumString(column: string, from: string, to: string, labelType: string) {
        let filter: WrapperStandardFilter = new WrapperStandardFilter();
        //this._filterArray = [];
        let arr: any = [];
        if (this._filterArray) {
            arr = this._filterArray.filter(function (el: any) {
                return el.Key !== column;
            });
        } else {
            this._filterArray = [];
        }
        this.setFilterArrCustom = arr;

        filter.Key = column;
        filter.OperatorType = null;
        filter.Value = from;
        this.setFilterArray = filter;
        if (from || to) {
            this.onCreateFilterChip(column, from, to, labelType);
        }
        this.getRequestData.PageSize = 1;
        this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData);
    };

    async PopulateLineItemDataOnSelectionGeneric(aUrl: string, aRequestData: WrapperStandardRequest<any>): Promise<Array<T>> {
        let result = this.genericService.PostAPIWithWrapperRequestAndReturnsArrayOfT(aUrl, aRequestData);
        // result.then((result: any) => {
        //     this.setLineItemData = result.responseData;
        // })
        return result;
    }
}

